import { DeleteTenantUserRequestSchema, DeleteTenantUserResponseSchema } from './delete-tenant-user.schema';
/**
 * Delete Tenant User Endpoint Contract
 * Deletes a user from a specific tenant (super-admin only)
 */ export const deleteTenantUserContract = {
    method: 'DELETE',
    path: '/api/v2/tenants/:tenantId/users/:userId',
    description: 'Delete a user from a specific tenant',
    requestSchema: DeleteTenantUserRequestSchema,
    responseSchema: DeleteTenantUserResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'User or tenant not found'
        }
    }
};

//# sourceMappingURL=delete-tenant-user.contract.js.map